'use client';
const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.df900e1012fb74acbc9bf08e07ec90cf.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.46185e0c9ca2fba640ca0dc32d0e8c8b.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.097bf70dcec47546d5895bd2023d07df.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.5114062dc18b0e61c89459448d66b13b.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.710495a890b50ac38b375827a0fe8bac.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.d54d2baa3034e379fce63d3adcf3dbbf.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.4e52d9069a843e8ca01301fc7f341565.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.e3d7c01b83b57808374ba6b3315fd47e.min.css',
        versioned: 'step-indicator.min.css'
    },
    statusMessage: {
        hashed: 'status-message.5a5dae6bd07da8296f6aedf3d0beb7aa.min.css',
        versioned: 'status-message.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.ba88f90b2f9704ba4f2a7b5dd8220600.min.css',
        versioned: 'standard-tile.min.css'
    },
    spinner: {
        hashed: 'spinner.eba95ed70aa0b14e2225c9ccdc3b13fd.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.4f1515ab24cf2ba508e76b224bc404de.min.css',
        versioned: 'selection-set.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.e164eed6ff785abfb972c16df7ae04b5.min.css',
        versioned: 'ratings-stars.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.fdfc36f7b52df977c340b85655ca082a.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.079ed7a8b72a43c295d80b33bc4a20b3.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.670ebdd75beb6a48402e9d16590ac3fb.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.3618b1689e9164a03fcbd21c40f596aa.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.e6a900a20f31b416553b0fecdf99fa76.min.css',
        versioned: 'modal-dialog.min.css'
    },
    listbox: {
        hashed: 'listbox.22e9df2209c0bccb1e5deeab2450ae55.min.css',
        versioned: 'listbox.min.css'
    },
    icon: {
        hashed: 'icon.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.393ab9dc32ba1b6be15bf4d30fc3c6d6.min.css',
        versioned: 'grid.min.css'
    },
    fileTile: {
        hashed: 'file-tile.a2abe00c2dcd2ae4d95cc96ed8d6fccc.min.css',
        versioned: 'file-tile.min.css'
    },
    fileDropzone: {
        hashed: 'file-dropzone.d6222005489e0477d16f8f8aa0316690.min.css',
        versioned: 'file-dropzone.min.css'
    },
    fieldSet: {
        hashed: 'field-set.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'field-set.min.css'
    },
    emptyState: {
        hashed: 'empty-state.46e5c6ac5dc9486f3ced02f03841f060.min.css',
        versioned: 'empty-state.min.css'
    },
    carousel: {
        hashed: 'carousel.80cb45fdac9512c7f409693f91062afc.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.d41d8cd98f00b204e9800998ecf8427e.min.css',
        versioned: 'button.min.css'
    },
    baseTile: {
        hashed: 'base-tile.76bdbbb3cbef836fb15b21fe2deec532.min.css',
        versioned: 'base-tile.min.css'
    },
    banner: {
        hashed: 'banner.78551d724083d7ec13c01ec84435a51a.min.css',
        versioned: 'banner.min.css'
    },
    avatar: {
        hashed: 'avatar.d67d114201fbc23f9ebe19c0ae0dd88d.min.css',
        versioned: 'avatar.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.e2797e34f01e79fc2a28fb66880054f7.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.357d9c0c080da164c0eef6e2341e2572.min.css',
        versioned: 'alert-box.min.css'
    },
    adaptiveCarousel: {
        hashed: 'adaptive-carousel.1b365052089a448f6a9eb1a7f170b817.min.css',
        versioned: 'adaptive-carousel.min.css'
    },
    accordion: {
        hashed: 'accordion.b1cc9beb570dd47b8288e61ec77a4568.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
